import * as z from "zod";
//#region src/__generated__/viewer/typicalMarkupController/zod/typicalMarkupDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const typicalMarkupDtoSchema = z.object({
	description: z.string(),
	id: z.uuid().nullish(),
	regulatoryActs: z.string(),
	type: z.string()
});
//#endregion
//#region src/__generated__/viewer/typicalMarkupController/zod/getAllSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getAllStatus200Schema = z.array(typicalMarkupDtoSchema);
const getAllResponseSchema = getAllStatus200Schema;
//#endregion
export { getAllStatus200Schema as n, typicalMarkupDtoSchema as r, getAllResponseSchema as t };

//# sourceMappingURL=getAllSchema.js.map